import { render } from "./Hamburger.vue?vue&type=template&id=b5acb7fa&scoped=true"
import script from "./Hamburger.vue?vue&type=script&lang=js"
export * from "./Hamburger.vue?vue&type=script&lang=js"

import "./Hamburger.vue?vue&type=style&index=0&id=b5acb7fa&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5acb7fa"]])

export default __exports__